module.exports = __webpack_public_path__ + "img/jelen_van_bg_768_cs.367df15c.png";